//import Moment from "moment";

const getCount = (state) => {
	return state.local.length;
}

export default {
	getCount
}